// OmyBoat cart-manager.js — single-reservation enforcement + resume banner
(function () {
  'use strict';
  var CHECKOUT = '/checkout';

  function xhrP(method, url) {
    return new Promise(function (res, rej) {
      var x = new XMLHttpRequest();
      x.open(method, url, true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () { try { res(JSON.parse(x.responseText)); } catch(e) { res({}); } };
      x.onerror = rej;
      x.send();
    });
  }
  function getCart()  { return xhrP('GET',  '/cart.js'); }
  function clearCart(){ return xhrP('POST', '/cart/clear.js'); }

  var _fetch = window.fetch.bind(window);
  var bannerEl = null;

  function showBanner() {
    bannerEl = document.getElementById('omyboat-cart-banner');
    if (!bannerEl) return;
    var fr = (document.documentElement.lang || 'fr').indexOf('en') !== 0;
    renderNormal(fr);
    document.body.classList.add('has-cart-banner');
    bannerEl.classList.add('crb--visible');
  }

  function renderNormal(fr) {
    bannerEl.innerHTML =
      '<div class="crb-inner"><span class="crb-icon">\u26F5</span>' +
      '<span class="crb-text">' + (fr ? 'R\u00e9servation en cours' : 'Reservation in progress') + '</span>' +
      '<a href="' + CHECKOUT + '" class="crb-btn crb-btn--resume">' + (fr ? 'Reprendre \u2192' : 'Resume \u2192') + '</a>' +
      '<button class="crb-btn crb-btn--cancel">' + (fr ? 'Annuler' : 'Cancel') + '</button></div>';
    bannerEl.querySelector('.crb-btn--cancel').addEventListener('click', function () { renderConfirm(fr); });
  }

  function renderConfirm(fr) {
    bannerEl.innerHTML =
      '<div class="crb-inner"><span class="crb-icon">\u26a0\ufe0f</span>' +
      '<span class="crb-text">' + (fr ? 'Annuler cette r\u00e9servation ?' : 'Cancel this reservation?') + '</span>' +
      '<button class="crb-btn crb-btn--confirm-yes">' + (fr ? 'Oui, annuler' : 'Yes, cancel') + '</button>' +
      '<button class="crb-btn crb-btn--confirm-no">' + (fr ? 'Non, garder' : 'Keep it') + '</button></div>';
    bannerEl.querySelector('.crb-btn--confirm-yes').addEventListener('click', function () {
      clearCart().then(hideBanner);
    });
    bannerEl.querySelector('.crb-btn--confirm-no').addEventListener('click', function () { renderNormal(fr); });
  }

  function hideBanner() {
    if (!bannerEl) return;
    bannerEl.classList.remove('crb--visible');
    document.body.classList.remove('has-cart-banner');
    setTimeout(function () { if (bannerEl && !bannerEl.classList.contains('crb--visible')) bannerEl.innerHTML = ''; }, 350);
  }

  var modalEl = null;
  function showModal(onResume, onReplace) {
    if (!modalEl) { modalEl = document.createElement('div'); modalEl.className = 'ccm-overlay'; document.body.appendChild(modalEl); }
    var fr = (document.documentElement.lang || 'fr').indexOf('en') !== 0;
    modalEl.innerHTML =
      '<div class="ccm-box"><div class="ccm-icon">\u26F5</div>' +
      '<div class="ccm-content">' +
      '<h3 class="ccm-title">' + (fr ? 'R\u00e9servation en cours' : 'Reservation in progress') + '</h3>' +
      '<p class="ccm-body">' + (fr ? 'Vous avez d\u00e9j\u00e0 une r\u00e9servation en cours.' : 'You already have a reservation in progress.') + '</p>' +
      '</div>' +
      '<div class="ccm-actions">' +
      '<button class="ccm-btn ccm-btn--resume">' + (fr ? '\u2192 Reprendre' : '\u2192 Resume') + '</button>' +
      '<button class="ccm-btn ccm-btn--replace">' + (fr ? 'Remplacer' : 'Replace') + '</button>' +
      '</div></div>';
    modalEl.style.display = 'block';
    modalEl.querySelector('.ccm-btn--resume').addEventListener('click', function () { modalEl.style.display = 'none'; onResume(); });
    modalEl.querySelector('.ccm-btn--replace').addEventListener('click', function () { modalEl.style.display = 'none'; onReplace(); });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method ? init.method : 'GET').toUpperCase();
    if (url.indexOf('/cart/add') !== -1 && method === 'POST') {
      // Guard fail-open : si /cart.js echoue (perte reseau mobile, requete annulee),
      // on ne bloque pas l'ajout au panier — cart vide => on tombe direct sur _fetch.
      return getCart().catch(function () { return {}; }).then(function (cart) {
        if (cart.item_count > 0) {
          return new Promise(function (resolve, reject) {
            showModal(
              function () { window.location.href = CHECKOUT; },
              function () { clearCart().then(function () { hideBanner(); return _fetch(input, init); }).then(resolve, reject); }
            );
          });
        }
        return _fetch(input, init);
      });
    }
    return _fetch(input, init);
  };

  // Defer garantit que le DOM est pret — on lance directement sans attendre DOMContentLoaded
  // setTimeout(0) s'assure que BTA a fini de charger ses scripts avant notre check
  setTimeout(function () {
    var p = window.location.pathname;
    if (p.indexOf('/checkouts') !== -1 || p === '/checkout') return;
    getCart().then(function (cart) {
      if (cart.item_count > 0) showBanner();
    }).catch(function () {}); // /cart.js KO (reseau mobile) => pas de banniere, pas de rejet non gere
  }, 300);
}());
